import { render, staticRenderFns } from "./CustomersRegistryEditForm.vue?vue&type=template&id=125c829b"
import script from "./CustomersRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./CustomersRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports